import React, { useState, useEffect } from 'react';
import { Grid, Card, Icon, Button, Tab, Message, Segment } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import GlassPageWrapper from '../../components/Layout/GlassPageWrapper';
import DocumentationSection from './components/DocumentationSection';
import QuizSection from './components/QuizSection';
import { useQuiz } from '../../context/QuizContext';

const LearningPage: React.FC = () => {
  const navigate = useNavigate();
  const { isQuizInProgress, quizId } = useQuiz();
  const [activeTab, setActiveTab] = useState(0);

  // Redirecionar para o quiz ativo se houver tentativa em andamento
  useEffect(() => {
    if (isQuizInProgress && quizId) {
      navigate(`/learning/quizzes/${quizId}/take`, { replace: true });
    }
  }, [isQuizInProgress, quizId, navigate]);

  const panes = [
    {
      menuItem: 'Documentação',
      render: () => (
        <Tab.Pane attached={false}>
          <DocumentationSection />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Questionários',
      render: () => (
        <Tab.Pane attached={false}>
          <QuizSection />
        </Tab.Pane>
      ),
    },
  ];

  // Se há quiz em andamento, mostrar mensagem enquanto redireciona
  if (isQuizInProgress) {
    return (
      <GlassPageWrapper
        title="Questionário em Andamento"
        icon="hourglass half"
      >
        <Message warning>
          <Message.Header>
            <Icon name="exclamation triangle" />
            Você tem um questionário em andamento
          </Message.Header>
          <p>
            Você não pode acessar o Centro de Aprendizado enquanto tiver uma tentativa de questionário em andamento.
            Redirecionando para o questionário...
          </p>
        </Message>
      </GlassPageWrapper>
    );
  }

  return (
    <GlassPageWrapper
      title="Centro de Aprendizado"
      icon="graduation cap"
    >
      <div style={{ marginBottom: '20px' }}>
        <Message info>
          <Message.Header>Bem-vindo ao Centro de Aprendizado!</Message.Header>
          <p>
            Aqui você encontrará toda a documentação do sistema Gettel e poderá testar seus conhecimentos através de questionários interativos.
            Mantenha-se atualizado com as melhores práticas e funcionalidades do sistema.
          </p>
        </Message>
      </div>

      <Tab
        menu={{ secondary: true, pointing: true }}
        panes={panes}
        activeIndex={activeTab}
        onTabChange={(_, data) => setActiveTab(data.activeIndex as number)}
      />
    </GlassPageWrapper>
  );
};

export default LearningPage;
